import { Injectable } from '@angular/core';

import * as c3 from 'c3';
import * as d3 from 'd3';
import { AppStatus } from '../interfaces/app-status.interface';

@Injectable({
    providedIn: 'root'
})
export class D3GraphService {

    constructor() { }

    drawProducerDonutGraph(statusData: AppStatus, donutChartElementId: string) {
        let donutChart;
        let totalCount = 0;
        const updateLegend = () => {
            const doNutDoIt = donutChart.data();

            const donutValues = doNutDoIt.map(arc => {
                return arc.values[0].value;
            });

            const activeDonutLabels = doNutDoIt.map(arc => {
                return arc.values[0].id;
            });
            d3.select(document.querySelector('#pd').shadowRoot)
                .select('.section3 .legend').remove();

            // Custom Legend
            d3.select(document.querySelector('#pd').shadowRoot).select('.section3')
                .insert('div', '.chart')
                .attr('class', 'legend')
                .selectAll('div')
                .data(activeDonutLabels)
                .enter()
                .append('div')
                .attr('class', 'sublegend')
                .attr('id', (id: string) => {
                    return id;
                })
                .html((id: string, index: number) => {
                    return id;
                })
                .each((id, index, htmlNodes) => {
                    d3.select(document.querySelector('#pd').shadowRoot).select(' #' + htmlNodes[index].getAttribute('id'))
                        .append('div')
                        .style('background-color', donutChart.color(id));
                    d3.select(document.querySelector('#pd').shadowRoot).select(' #' + htmlNodes[index].getAttribute('id'))
                        .append('span')
                        .attr('class', 'legend-label')
                        .html((nodeId, index2) => {
                            return donutValues[index];
                        });
                })
                .on('mouseover', id => {
                    donutChart.focus(id);
                })
                .on('mouseout', id => {
                    donutChart.revert();
                })
                .on('click', id => {
                    d3.select(document.querySelector('#pd').shadowRoot).select('svg').selectAll('.legend_values').remove();
                    d3.select(document.querySelector('#pd').shadowRoot).select('#values')
                        .selectAll('p')
                        .data(donutChart.data(id)[0].values)
                        .enter()
                        .append('p')
                        .text((d: HTMLParagraphElement) => {
                            // return d.value;
                            return d.nodeValue;
                        })
                        .classed('legend_values', true);
                });
        };

        const generateDonutGraph = graph => {
            donutChart = c3.generate({
                padding: {
                    top: 15,
                    right: 1,
                    bottom: 15,
                    left: 10
                },
                bindto: document.getElementById('pd').shadowRoot.getElementById(donutChartElementId),
                gauge: {
                    expand: false,
                    fullCircle: true,
                    width: 35
                },
                size: {
                    height: 300
                },
                data: {
                    columns: graph,
                    type: 'donut',
                    colors: {

                    },
                    groups: [
                        [
                        ]
                    ]
                },
                legend: {
                    hide: true,
                    show: false
                },
              tooltip: {
                position: (data, width, height, element) => {
                  const chartOffsetX = document.getElementById('pd').shadowRoot.getElementById(donutChartElementId).getBoundingClientRect().left;
                  const chartOffsetY = document.getElementById('pd').shadowRoot.getElementById(donutChartElementId).getBoundingClientRect().top;
                  const mouseX = ( d3.event as any).pageX;
                  const mouseY = (d3.event as any).pageY;
                  const tooltipLeft = Math.max(0, mouseX - chartOffsetX - width / 2);
                  const tooltipTop = Math.max(0, mouseY - chartOffsetY - height - 10); // 10px above the cursor
                  return { top: tooltipTop, left: tooltipLeft };
                }
              },
                axis: {
                    x: {
                        type: 'category',
                        tick: {
                            values:[]
                        }
                    },
                    y: {
                        padding: { top: 250 },
                        tick: {
                            values:[]
                        }
                    },
                    y2: {
                        tick: {
                            values:[]
                        }
                    }
                },
                onrendered() {
                }
            });

            // Enhanced Title
            d3.select(document.querySelector('#pd').shadowRoot).select('#' + donutChartElementId + ' .c3-chart-arcs')
                .append('text')
                .attr('text-anchor', 'middle')
                .attr('font-size', '24px')
                .attr('y', 0)
                .attr('data-total-value', 'true')
                .attr('class', 'donut-text')
                .text(totalCount);

            d3.select(document.querySelector('#pd').shadowRoot).select('#' + donutChartElementId + ' .c3-chart-arcs')
                .append('text')
                .attr('text-anchor', 'middle')
                .attr('font-size', '14px')
                .attr('y', 22)
                .attr('data-total-label', 'true')
                .attr('class', 'donut-text')
                .text('Total');

            d3.select(document.querySelector('#pd').shadowRoot).select('#' + donutChartElementId + ' .c3-chart-arcs')
                .append('text')
                .attr('text-anchor', 'middle')
                .attr('font-size', '14px')
                .attr('y', 40)
                .attr('data-time-label', 'true')
                .attr('class', 'donut-text')
                .text('Applications');

            donutChart.data().map(arc => {
              console.log('values ', arc.values[0].id);
              d3.select(document.querySelector('#pd').shadowRoot).select('#' + donutChartElementId + ' .c3-chart-arcs .c3-target-' + arc.values[0].id)
                .attr('aria-label', arc.values[0].id);

              d3.select(document.querySelector('#pd').shadowRoot).select('#' + donutChartElementId + ' .c3-chart-arcs .c3-target-' + arc.values[0].id + ' .c3-arcs-' + arc.values[0].id + ' .c3-arc-' + arc.values[0].id)
                .style('cursor', 'default');

            });
            // Create Legend
            updateLegend();
        };

        setTimeout(
            function () {
                const graph = [];
                for (const [key, value] of Object.entries(statusData)) {
                    const tempArr = [];
                    // TODO: is replacing this with underscores necessary? what do we do here and why?
                    const tempKey1 = key.split(' ').join('_');
                    const tempKey = tempKey1.split('/').join('_');
                    const newKey = tempKey.charAt(0).toUpperCase() + tempKey.slice(1);
                    tempArr.push(newKey);
                    tempArr.push(value);
                    graph.push(tempArr);
                    totalCount = totalCount + Number(value);
                }
                generateDonutGraph(graph);
            }.bind(this),
            0
        );
    }

}
